import { useState } from 'react';

interface WatchVideoButtonProps {
  onClick: () => void;
  disabled?: boolean;
  compact?: boolean;
  id?: string;
}

const WatchVideoButton = ({ onClick, disabled = false, compact = false, id }: WatchVideoButtonProps) => {
  const [hovered, setHovered] = useState(false);
  const baseColor = disabled ? '#aaa' : '#1E6DBB';
  const color = !disabled && hovered ? '#134D85' : baseColor;

  return (
    <button
      onClick={onClick}
      disabled={disabled}
      id={id}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: compact ? '0.5rem' : '0.6rem',
        width: '100%',
        padding: compact ? '0.2rem' : '0.3rem',
        background: 'none',
        border: 'none',
        color,
        fontSize: compact ? '0.8rem' : '0.95rem',
        fontWeight: 500,
        cursor: disabled ? 'not-allowed' : 'pointer',
        marginBottom: '0.15rem',
        transition: 'color 0.2s ease',
      }}
    >
      <i className="far fa-play" style={{ fontSize: compact ? '0.9rem' : '1.05rem', color, transition: 'color 0.2s ease' }}></i>
      Watch Tutorial Video
    </button>
  );
};

export default WatchVideoButton;
